// D2 — Web Documentation: article status/version badge (TechSpec §9, §16).
//
// Renders the user-facing status of an article. `future` is visually and
// semantically distinct from `current` — it must never read as "this works
// today" (D2-A9). `deprecated` carries an explicit warning. `current` is the
// quiet default.

import { CircleAlert, Clock } from "lucide-react";
import type { DocStatus } from "@/lib/docs/types";

const STATUS_RU: Record<DocStatus, string> = {
  current: "Актуально",
  deprecated: "Устарело",
  future: "Скоро",
};

export function StatusBadge({ status }: { status: DocStatus }) {
  if (status === "current") {
    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full border border-strongline bg-hoverbg px-2.5 py-0.5 text-[11px] font-medium text-secondary"
        aria-label="Статья актуальна"
      >
        Актуально
      </span>
    );
  }
  if (status === "deprecated") {
    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-amber-500/10 px-2.5 py-0.5 text-[11px] font-medium text-amber-500"
        aria-label="Статья устарела"
      >
        <CircleAlert size={12} />
        Устарело
      </span>
    );
  }
  // future — must be unmistakably "not available yet"
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border border-accent/40 bg-accent/10 px-2.5 py-0.5 text-[11px] font-semibold text-accent"
      aria-label="Функция появится в будущем"
    >
      <Clock size={12} />
      {STATUS_RU[status]}
    </span>
  );
}

export const STATUS_RU_LABEL = STATUS_RU;
